import styled from 'styled-components'
import { colors } from './colors'

export const ContactsContainer = styled.section`
    position: relative;
    overflow: hidden;

    //  INCLUDED CLASSES:

    .background-rectangle {
        position: absolute;
        background: ${colors.dark_blue};
        transform: rotate(45deg);
        z-index: -1;

        transition: all .5s;

        @media (min-width: 1440px) {
            height: 598px;

            right: -430px;
            top: -160px;
        }
        
        @media (min-width: 960px) and (max-width: 1439.98px) {
            height: 598px;

            right: -630px;
            top: -260px;
        }
        @media (min-width: 960px) {
            width: 1194px;
        }
        @media (min-width: 768px) and (max-width: 959.98px) {
            width: 442px;
            height: 258px;
    
            right: -230px;
            top: -80px;
        }
    }

    .width-limiter {
        @media (min-width: 1440px) {
            padding: 18rem 6.75rem 25rem 6.75rem;
        }
        @media (min-width: 321px) and (max-width: 1439.98px) {
            padding: 18rem 6.75rem;
        }
        @media (max-width: 320px) {
            padding: 7.5rem 2rem;
        }
    }

    .text-container {
        display: flex;      

        :not(:last-child) {
            margin-bottom: 7.25rem;
        }

        @media (max-width: 320px) {
            :not(:last-child) {
                margin-bottom: 5rem;
            }
        }
    }

    .dot {
        border-radius: 50%;
        background: ${colors.dark_blue};
        margin: 1.5rem;

        @media (min-width: 1920px) {
            margin: 2rem;
        }
        @media (min-width: 321px) {
            min-width: 15px;
            height: 15px;
        }
        @media (max-width: 320px) {
            min-width: 10px;
            height: 10px;
        }
    }

    .text {

        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        line-height: 160%;
        color: ${colors.dark_blue};

        @media (min-width: 1920px) {
            font-size: 3.75rem;
            max-width: 940px;
        }
        @media (min-width: 321px) and (max-width: 1919.98px) {
            font-size: 3rem;
            max-width: 660px;
        }
        @media (max-width: 320px) {
            font-size: 2.25rem;
        }
    }
`

export const ServiceContainer = ContactsContainer